import { useEffect, useRef } from 'react';

const REVEAL_SELECTOR = '.reveal, .reveal-left, .reveal-right, .reveal-scale';

export default function useScrollReveal(options = {}) {
    const ref = useRef(null);

    useEffect(() => {
        const el = ref.current;
        if (!el) return;

        const threshold = options.threshold || 0.1;
        const rootMargin = options.rootMargin || '0px 0px -50px 0px';

        const observed = new WeakSet();

        const io = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        entry.target.classList.add('visible');
                        io.unobserve(entry.target);
                    }
                });
            },
            { threshold, rootMargin }
        );

        const observeNew = () => {
            el.querySelectorAll(REVEAL_SELECTOR).forEach((target) => {
                if (!observed.has(target) && !target.classList.contains('visible')) {
                    observed.add(target);
                    io.observe(target);
                }
            });
        };

        // Observe existing elements
        observeNew();

        // Watch for dynamically added elements
        const mo = new MutationObserver(observeNew);
        mo.observe(el, { childList: true, subtree: true });

        return () => {
            io.disconnect();
            mo.disconnect();
        };
    }, [options.threshold, options.rootMargin]);

    return ref;
}
